module.exports = __webpack_public_path__ + "assets/img/zhijiaob_5013_4.788d08eb.jpg";